import baseConfig from '@config/baseConfig';

const phaserConfig = baseConfig();

export const config = {
  width: phaserConfig.width,
  height: phaserConfig.height,
  audio: {
    bgaudio: null,
    correctAnswer: null,
    wrongAnswer: null,
    waterCan: null,
    watering: null,
    flowerBlossoming: null,
    hover: null,
    hintAlert: null,
    yay: null,
    ta1: null,
    ta2: null,
    ta3: null,
    ta4: null,
  },
};

export const gameState = {
  score: 0,
  attempted: 0,
  questionNumber: 0,
  hints: 0,
  gameWin: false,
  firstMistake: false,
};
